<template>
  <div>
    <el-container>
      <!-- <el-header > -->
      <myHeader />
      <!-- </el-header> -->
      <el-container>
        <!-- <el-aside :style="{width:isCollapse?'auto':''}">
          </el-aside> -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>

      <el-footer >
        <myFooter />
      </el-footer>
    </el-container>
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  components: {},
  data() {
    return {
      isCollapse: false,
    };
  },

  created() {

  },
  methods: {
    isStatus(data) {
      console.log(data, 'data');
      this.isCollapse = data
    }

  },

}
</script>
<style lang="scss">
@import 'animate.css';

.el-main {
  padding: 0;
  margin: 0;
}

.el-footer {
  padding: 0px 0;
  margin: 0;
  // box-shadow: 0 -5px 10px rgba(40, 167, 233, 0.5) !important;
}

// 添加路由过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 确保滚动动画元素初始状态
[v-scroll-animation] {
  opacity: 0;

  &.animate__animated {
    opacity: 1;
  }
}
</style>
